// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_container__tXouC {
    position: fixed;
    top: 0;
    right: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 50%;
    height: 50%;
    z-index: 3600;
    /* background-color: rgba(0,0,0,0.54); */
    opacity: 1;
    transition: all 0.5s;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/WebcamComponent/style.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,aAAa;IACb,wCAAwC;IACxC,UAAU;IACV,oBAAoB;AACxB","sourcesContent":[".container {\n    position: fixed;\n    top: 0;\n    right: 0;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    width: 50%;\n    height: 50%;\n    z-index: 3600;\n    /* background-color: rgba(0,0,0,0.54); */\n    opacity: 1;\n    transition: all 0.5s;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style_container__tXouC`
};
export default ___CSS_LOADER_EXPORT___;
